var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.9072L12.49 20.379C11.4475 21.4169 10.0335 22 8.55913 22C7.08476 22 5.67077 21.4169 4.62824 20.379C3.58569 19.3412 3 17.9335 3 16.4657C3 14.998 3.58569 13.5904 4.62824 12.5525L13.1382 4.08062C13.8333 3.38871 14.7759 3 15.7588 3C16.7418 3 17.6844 3.38871 18.3794 4.08062C19.0745 4.77254 19.465 5.71097 19.465 6.68947C19.465 7.66798 19.0745 8.60641 18.3794 9.29832L9.86017 17.7702C9.51266 18.1161 9.04132 18.3105 8.54987 18.3105C8.05841 18.3105 7.58709 18.1161 7.23957 17.7702C6.89206 17.4242 6.69682 16.9551 6.69682 16.4657C6.69682 15.9765 6.89206 15.5073 7.23957 15.1613L15.1013 7.34399",
    stroke: "#9FA6AD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.1c7f268c03deb698ba0b9f579ab1ea67.svg";
export { ForwardRef as ReactComponent };